import { render, staticRenderFns } from "./two_images_two_buttons_with_legend.vue?vue&type=template&id=0f388df5&"
import script from "./two_images_two_buttons_with_legend.vue?vue&type=script&lang=js&"
export * from "./two_images_two_buttons_with_legend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports